/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Metering dimensions for cost analysis across different cloud providers and resource types
*/
export enum MeteringDimension {
  AwsEc2MeteringDimension = 'AWS_EC2_METERING_DIMENSION',
  AwsEc2RansomwareProtectedStorageMeteringDimension = 'AWS_EC2_RANSOMWARE_PROTECTED_STORAGE_METERING_DIMENSION',
  AwsRdsMeteringDimension = 'AWS_RDS_METERING_DIMENSION',
  AwsS3MeteringDimension = 'AWS_S3_METERING_DIMENSION',
  AwsS3RansomwareProtectedStorageMeteringDimension = 'AWS_S3_RANSOMWARE_PROTECTED_STORAGE_METERING_DIMENSION',
  AwsDynamoDbMeteringDimension = 'AWS_DYNAMO_DB_METERING_DIMENSION',
  AwsEksMeteringDimension = 'AWS_EKS_METERING_DIMENSION',
  AzureVirtualMachineMeteringDimension = 'AZURE_VIRTUAL_MACHINE_METERING_DIMENSION',
  AzureVirtualMachineRansomwareProtectedStorageMeteringDimension = 'AZURE_VIRTUAL_MACHINE_RANSOMWARE_PROTECTED_STORAGE_METERING_DIMENSION',
  AzureStorageAccountMeteringDimension = 'AZURE_STORAGE_ACCOUNT_METERING_DIMENSION',
  GcpVmInstanceMeteringDimension = 'GCP_VM_INSTANCE_METERING_DIMENSION',
  GcpCloudStorageMeteringDimension = 'GCP_CLOUD_STORAGE_METERING_DIMENSION',
  GcpCloudSqlPostgresSqlMeteringDimension = 'GCP_CLOUD_SQL_POSTGRES_SQL_METERING_DIMENSION',
  GcpCloudSqlMysqlMeteringDimension = 'GCP_CLOUD_SQL_MYSQL_METERING_DIMENSION',
  GcpCloudSqlSqlServerMeteringDimension = 'GCP_CLOUD_SQL_SQL_SERVER_METERING_DIMENSION',
  DataTransferMeteringDimension = 'DATA_TRANSFER_METERING_DIMENSION',
  CrossCloudDataTransferMeteringDimension = 'CROSS_CLOUD_DATA_TRANSFER_METERING_DIMENSION',
  AwsEc2ToAzureVaultMeteringDimension = 'AWS_EC2_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsEc2RansomwareProtectedStorageToAzureVaultMeteringDimension = 'AWS_EC2_RANSOMWARE_PROTECTED_STORAGE_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsS3ToAzureVaultMeteringDimension = 'AWS_S3_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsS3RansomwareProtectedStorageToAzureVaultMeteringDimension = 'AWS_S3_RANSOMWARE_PROTECTED_STORAGE_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsRdsToAzureVaultMeteringDimension = 'AWS_RDS_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsDynamoDbToAzureVaultMeteringDimension = 'AWS_DYNAMO_DB_TO_AZURE_VAULT_METERING_DIMENSION',
  AwsEksToAzureVaultMeteringDimension = 'AWS_EKS_TO_AZURE_VAULT_METERING_DIMENSION',
  AzureVirtualMachineToAwsVaultMeteringDimension = 'AZURE_VIRTUAL_MACHINE_TO_AWS_VAULT_METERING_DIMENSION',
  AzureVirtualMachineRansomwareProtectedStorageToAwsVaultMeteringDimension = 'AZURE_VIRTUAL_MACHINE_RANSOMWARE_PROTECTED_STORAGE_TO_AWS_VAULT_METERING_DIMENSION',
  AzureStorageAccountToAwsVaultMeteringDimension = 'AZURE_STORAGE_ACCOUNT_TO_AWS_VAULT_METERING_DIMENSION'
}
